<template>
	<div class="i-date-interval">
		С
		<i-date-picker/>
		По 
		<i-date-picker/>
	</div>
</template>

<script>
export default {

  name: 'i-date-interval',

  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
</style>